import { T, useTheme, dens, Ico, Card, Eyebrow, Badge } from '../../../design';
import type { Course } from '../../../types/courses.types';
import { fmtDate, fmtPrice, fmtTime } from '../../../utils';
import { availInfo, CourseImage, courseImages } from '../courseUtils';
import { EmptyState } from './states';

function CourseCard({ course, onOpen }: { course: Course; onOpen: (c: Course) => void }) {
  const t = useTheme();
  const av = availInfo(course);
  const img = courseImages(course)[0] ?? null;
  return (
    <Card pad={0} onClick={() => onOpen(course)} style={{ cursor: 'pointer', overflow: 'hidden', opacity: av.disabled ? 0.85 : 1 }}>
      <div style={{ display: 'flex', gap: 0 }}>
        <div style={{ width: 104, flexShrink: 0, padding: 12 }}><CourseImage src={img} alt="foto" height={130} radius={10} /></div>
        <div style={{ flex: 1, minWidth: 0, padding: '13px 14px 13px 2px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 5 }}>
            <Badge tone={av.tone} dot>{av.label}</Badge>
            {course.courseType === 'external' && <Badge tone="neutral">Ekstern</Badge>}
          </div>
          <div style={{ fontSize: 15, fontWeight: 800, color: T.fg, letterSpacing: '-0.01em', lineHeight: 1.25 }}>{course.productName}</div>
          <div style={{ fontSize: 12, color: T.fg3, fontWeight: 600, marginTop: 6, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><Ico.clock size={13} />{fmtDate(course.courseDate)}{course.startTime ? ` · ${fmtTime(course.startTime)}` : ''}</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><Ico.store size={13} />{course.location || 'Oplyses senere'}</span>
          </div>
          <div style={{ flex: 1 }} />
          <div style={{ fontSize: 14, fontWeight: 800, color: t.accent, marginTop: 8 }}>{fmtPrice(course.price)}</div>
        </div>
      </div>
    </Card>
  );
}

export interface CourseListProps {
  courses: Course[];
  showPast: boolean;
  onTogglePast: () => void;
  onOpen: (course: Course) => void;
}

export function CourseList({ courses, showPast, onTogglePast, onOpen }: CourseListProps) {
  const t = useTheme();
  const d = dens(t);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: d.gap }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Eyebrow>Aktive kurser</Eyebrow>
        <button onClick={onTogglePast} style={{ display: 'flex', alignItems: 'center', gap: 6, border: 0, background: 'transparent', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: showPast ? t.accent : T.fg3, fontFamily: T.font }}>
          <span style={{ width: 16, height: 16, borderRadius: 5, border: `1.5px solid ${showPast ? t.accent : T.border}`, background: showPast ? t.accent : 'transparent', color: T.onAccent, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{showPast && <Ico.check size={11} />}</span>
          Vis afsluttede
        </button>
      </div>
      {courses.length === 0
        ? <EmptyState title="Ingen kurser" sub="Der er ingen kurser at vise lige nu." />
        : courses.map((c) => <CourseCard key={c.slug} course={c} onOpen={onOpen} />)}
    </div>
  );
}
